import { useContext } from "react";
import { UserContext } from "./UserProvider";

export const useUser=()=>{
    const value = useContext(UserContext)
    return value
}